import { useEffect, useState } from 'react'
import { CHAIN_ID, IS_LIVE, ZERO_ADDR } from '@/lib/contracts'


// DexScreener's own recognized chain slugs - same set BuySection's DEXSCREENER_CHAIN_SLUG
// already covers for the Buy page's embedded chart.
const DEXSCREENER_CHAIN_SLUG = { 1: 'ethereum', 8453: 'base', 42161: 'arbitrum', 10: 'optimism', 137: 'polygon' }

/// Real 24h trading volume for a Uniswap V3 pool, read from DexScreener's public pairs API -
/// this app has no subgraph/indexer of its own, and scanning Swap event logs back 24h on every
/// page load would be far too slow against a public RPC with no dedicated indexing. Same data
/// source the Buy page's embedded chart already uses, just the numeric API instead of the
/// iframe. Polled every minute - real trading volume doesn't move fast enough to need faster.
export function useDexScreenerVolume24h(poolAddress) {
  const [state, setState] = useState({ volume24h: 0, found: false })
  const chainSlug = DEXSCREENER_CHAIN_SLUG[CHAIN_ID]
  const enabled = IS_LIVE && !!chainSlug && !!poolAddress && poolAddress.toLowerCase() !== ZERO_ADDR

  useEffect(() => {
    if (!enabled) {
      setState({ volume24h: 0, found: false })
      return
    }
    let cancelled = false

    async function load() {
      try {
        const res = await fetch(`https://api.dexscreener.com/latest/dex/pairs/${chainSlug}/${poolAddress}`)
        if (!res.ok) throw new Error(`DexScreener responded ${res.status}`)
        const data = await res.json()
        const pair = Array.isArray(data?.pairs) ? data.pairs[0] : data?.pair
        const volume24h = Number(pair?.volume?.h24)
        if (!cancelled) {
          setState(Number.isFinite(volume24h) ? { volume24h, found: true } : { volume24h: 0, found: false })
        }
      } catch {
        if (!cancelled) setState({ volume24h: 0, found: false })
      }
    }

    load()
    const id = setInterval(load, 60_000)
    return () => { cancelled = true; clearInterval(id) }
  }, [enabled, chainSlug, poolAddress])

  return state
}
